import {useState} from 'react'
import {getCECO} from '../services'
import {CECOModel, SelectModel} from '../model'
import {mapDataSelect} from '../../../util/functions'
const useCecoService = () => {
  const [loading, setLoading] = useState(false)
  const [ceco, setCeco] = useState<SelectModel[]>([])

  const getCECOData = async (cecoParams: CECOModel, size: number=10) => {
    setLoading(true)
    try {
      const response = await getCECOService(cecoParams, size)
      return response.data.data
    } catch (error) {
      console.error('Error fetching ceco data:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getCECOService = async (cecoParams: CECOModel, size: number=10) => {
    let obj: CECOModel = {
      ...cecoParams,
    }
    return await getCECO(obj, 1, size)
  }

  const updateCecoList = (mappedSites: {value: string; label: string}[]) => {
    setCeco(mappedSites)
  }

  const getCECOList = async (cecoParams: CECOModel = {}, size: number=10) => {
    try {
      const data = await getCECOData(cecoParams, size)
      const mappedSites = mapDataSelect(data, 'centrodecosto', 'centrodecosto')
      updateCecoList(mappedSites)
    } catch (error) {
      console.error('Error fetching ceco data:', error)
    }
  }

  const handleClear = () => {
    setCeco([])
  }

  return {
    loading,
    ceco,
    handleClear,
    getCECOList,
  }
}
export default useCecoService
